import { combineReducers } from 'redux';

// Constants Types
import {
  COVERED_STATE_FETCH_REQUEST,
  COVERED_STATE_FETCH_SUCCESS,
  COVERED_STATE_FETCH_FAILURE,
  LICENSETABLE_FETCH_REQUEST,
  LICENSETABLE_FETCH_SUCCESS,
  LICENSETABLE_FETCH_FAILURE,
  LICENSETABLE_ADD_REQUEST,
  LICENSETABLE_ADD_SUCCESS,
  LICENSETABLE_ADD_FAILURE,
  LICENSETABLE_DELETE_REQUEST,
  LICENSETABLE_DELETE_SUCCESS,
  LICENSETABLE_DELETE_FAILURE,
  LICENSETABLE_EDIT_REQUEST,
  LICENSETABLE_EDIT_SUCCESS,
  LICENSETABLE_EDIT_FAILURE,
} from './types';

const initialState = {
  isRequesting: false,
  coveredState: [],
  licenseTable: [],
  error: {},
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [COVERED_STATE_FETCH_REQUEST]: (state, action) => ({
    ...state,
    isRequesting: true,
  }),
  [COVERED_STATE_FETCH_SUCCESS]: (state, action) => ({
    ...state,
    isRequesting: false,
    coveredState: action.payload,
  }),
  [COVERED_STATE_FETCH_FAILURE]: (state, action) => ({
    ...state,
    isRequesting: false,
    error: action.payload,
  }),
  [LICENSETABLE_FETCH_REQUEST]: (state, action) => ({
    ...state,
    isRequesting: true,
  }),
  [LICENSETABLE_FETCH_SUCCESS]: (state, action) => ({
    ...state,
    isRequesting: false,
    licenseTable: action.payload,
  }),
  [LICENSETABLE_FETCH_FAILURE]: (state, action) => ({
    ...state,
    isRequesting: false,
    error: action.payload,
  }),
  [LICENSETABLE_ADD_REQUEST]: (state, action) => ({
    ...state,
    isRequesting: true,
  }),
  [LICENSETABLE_ADD_SUCCESS]: (state, action) => ({
    ...state,
    isRequesting: false,
  }),
  [LICENSETABLE_ADD_FAILURE]: (state, action) => ({
    ...state,
    isRequesting: false,
    error: action.payload,
  }),
  [LICENSETABLE_DELETE_REQUEST]: (state, action) => ({
    ...state,
    isRequesting: true,
  }),
  [LICENSETABLE_DELETE_SUCCESS]: (state, action) => ({
    ...state,
    isRequesting: false,
  }),
  [LICENSETABLE_DELETE_FAILURE]: (state, action) => ({
    ...state,
    isRequesting: false,
    error: action.payload,
  }),
  [LICENSETABLE_EDIT_REQUEST]: (state, action) => ({
    ...state,
    isRequesting: true,
  }),
  [LICENSETABLE_EDIT_SUCCESS]: (state, action) => ({
    ...state,
    isRequesting: false,
  }),
  [LICENSETABLE_EDIT_FAILURE]: (state, action) => ({
    ...state,
    isRequesting: false,
    error: action.payload,
  }),
};

//
// Reducer
// ------------------------------------
const MyInfoSettings = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};

export default combineReducers({
  myInfoSettings: MyInfoSettings,
});



// WEBPACK FOOTER //
// ./src/views/state/MyInfoSettings/MyinfoSettingsReducers.js